import CONST from '../../../../../includes/primitives/_constant_trion'

export default {

  data: () => ({  

    HOST: CONST.HOST_NAME_RESOURCE + '/resources',
    
    canvasForm:     null,
    canvasTimeline: null,
    canvasSkyline:  null,
    canvasFront:    null,

    rawData:        null,
    skyData:        null,
    stageCodes:       [],

    Toggle:           'on',

    timeline: {
      baseX           : 40.5,
      baseY           : 910.5,
      length          : 1200,
      refColumn       : 'ETA', // ***
      weekEnd         : 'friday',
      week            : [],
      month           : [],
      year            : [],
      scale           : null,
      height          : 35,
    },
   
    skyline: {
      refColumn     : 'ETA',
      width         : 31,
      height        : 15,
      gap           : 2,
      radius        : 2.5,
      tSize         : 10,
    },
  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

}